import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';
import {
    getAccessToken,
    trackBusinessError,
} from '@sxm-de/dev-kits/web-sdk/utils';
import { acceptOfferAndRenewalTerms } from '@sxm-de/dev-kits/web-sdk/domains/agreements';

interface PayInvoiceStripeFnPayload {
    stripePaymentMethodId: string;
    giftCardId?: string;
    acceptAgreementRequest?: {
        version: string;
        language: string;
        countryCode: string;
    };
}

export type PayInvoiceStripeFn = (
    payload: PayInvoiceStripeFnPayload,
) => Promise<{
    billingProfileBalanceAfter: number;
}>;

export function initPayInvoiceStripeFn({
    dependencies,
}: DomainInitPayload): PayInvoiceStripeFn {
    return async ({
        stripePaymentMethodId,
        giftCardId,
        acceptAgreementRequest,
    }: PayInvoiceStripeFnPayload) => {
        const { appEventSdk, atlasSdk } = dependencies;

        try {
            const { id: billingProfileId } =
                await getDefaultBillingProfile(dependencies);

            const result: any = await atlasSdk.domains.commerce.payBalanceDue({
                billingProfileId,
                request: {
                    stripePaymentMethodId,
                    ...(giftCardId ? { giftCardId } : {}),
                },
                accessToken: getAccessToken(),
            });

            if (acceptAgreementRequest) {
                await acceptOfferAndRenewalTerms(
                    { ...acceptAgreementRequest },
                    dependencies,
                );
            }

            return giftCardId
                ? {
                      billingProfileBalanceAfter:
                          result?.billingProfileBalanceAfter?.value,
                  }
                : {
                      billingProfileBalanceAfter: 0,
                  };
        } catch (error: any) {
            if (
                error?.code ===
                    'commerceTeam.billingServiceService.payment_method_failed' ||
                error?.code ===
                    'commerceTeam.billingServiceService.payment_method_declined'
            ) {
                trackBusinessError(appEventSdk, error);
                throw new Error('CREDIT_CARD_ERROR');
            } else {
                /**
                 * TODO:
                 * Log error to error logger (not analytics).
                 */
                throw new Error('SYSTEM');
            }
        }
    };
}
